import {connect} from 'react-redux';

import {NewPanelId, RSettingsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {
  ConversationCardContainerBaseProps,
  makeGetAssignee,
  makeGetInbox,
  makeGetParticipants,
} from '../../../../srcCommon/inboxes/contactDetails/conversationsHistorySelectors';
import {findConversationReminder} from '../../../helpers/models/conversationHelpers';
import {ConversationModel} from '../../../models/api/conversationModel';
import {AppState} from '../../../store/appState';
import {getCurrentCellsPanelCellsContext} from '../../../store/panels/cells/cellsPanelSelectors';
import {getViewerPanel} from '../../../store/panels/panelsSelectors';
import {popoutConversationViewerAction} from '../../../store/panels/viewer/viewerPanelActions';
import {ViewerPanelPageTypesEnum} from '../../../store/panels/viewer/viewerPanelState';
import {ConversationCard} from './conversationCard';

/*
 * Props.
 */

interface ConversationCardContainerProps extends ConversationCardContainerBaseProps {
  panelId: NewPanelId;
}

/*
 * Selectors.
 */

function getConversation(_state: AppState, props: ConversationCardContainerProps) {
  return props.conversation;
}

function getPanelId(_state: AppState, props: ConversationCardContainerProps) {
  return props.panelId;
}

function makeGetViewerConversationId() {
  return createSelector([getPanelId, getViewerPanel], (panelId, viewerPanel) => {
    // If we are in settings, user don't see the current P3 conversation.
    if (RSettingsPanelId.is(panelId)) {
      return undefined;
    }

    const page = viewerPanel?.pages.current;
    return page?.type === ViewerPanelPageTypesEnum.SINGLE_CONVERSATION ? page.conversationId : undefined;
  });
}

function makeGetReminderDate() {
  return createSelector([getConversation, getCurrentCellsPanelCellsContext], (conversation, cellsContext) => {
    if (cellsContext) {
      const reminder = findConversationReminder(cellsContext, conversation);
      return reminder?.remindAt;
    }

    return undefined;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationCardContainerProps>()(() => {
  const getAssignee = makeGetAssignee();
  return {
    inbox: makeGetInbox(),
    assignee: getAssignee,
    participants: makeGetParticipants(getAssignee),
    viewerConversationId: makeGetViewerConversationId(),
    reminderDate: makeGetReminderDate(),
  };
});

const mapDispatchToProps = makeMapDispatchToProps<ConversationCardContainerProps>()(() => ({
  openConversation: (conversation: ConversationModel) => popoutConversationViewerAction(conversation.id),
}));

export const ConversationCardContainer = connect(mapStateToProps, mapDispatchToProps)(ConversationCard);
